import React from "react";
import Image from "react-bootstrap/esm/Image";
import { useNavigate } from "react-router-dom";
import "../CategoryListGrid.css";

export default function CategoryListGrid(props) {
  const { resetToHead, categories } = props;
  const navigate = useNavigate();

  return (
    <div
      className="bg-white category-grid-container"
      style={{
        overflow: "auto",
      }}
    >
      {categories.map((c) => (
        <div
          key={c._id}
          onClick={() => {
            resetToHead();
            navigate(`/category/order?rootCategory=${c._id}`);
          }}
          className="category-grid-image-container"
        >
          <Image
            src={c.image}
            alt={c.name}
            fluid
            className="category-grid-image"
          />
          <div className="category-grid-label">
            <span>{c.name}</span>
          </div>
        </div>
      ))}
      {categories.length === 0 && (
        <div className="empty-grid">
          <span>Kategori Yok!</span>
        </div>
      )}
    </div>
  );
}
